import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Translate } from '../../../../../../../shared/LanguageService';

const Badge = styled('span')({
    fontSize: '10px',
    borderRadius: '4px',
    color: '#fff',
    backgroundColor: '#F57C00',
    padding: '2px 6px',
    whiteSpace: 'nowrap'
});

export function CategoryExtra() {
    return (
        <Badge>
            {Translate('image-processing/page/list/thumbnail/caption/extra')}
        </Badge>
    );
}
